import { gql } from '@apollo/client'

export const PAYMENT_REMINDER_MUTATION = gql`
  mutation paymentReminder($paymentId: ID!) {
    paymentReminder(paymentId: $paymentId) {
      stripeCheckoutUrl
    }
  }
`
